import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { BUILD_INFO, formatBuildLabel } from './shell/buildInfo.js';

// Print once on boot so bug-report screenshots that include the console
// already identify the build — saves a round-trip asking "what version?"
console.info(
  `%c[ops-platform-v3] ${formatBuildLabel()} %cbuilt ${BUILD_INFO.builtAt}`,
  'font-weight:bold',
  'color:#6b7280',
);

const container = document.getElementById('root');
if (!container) throw new Error('#root not found in index.html');
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
